import { render } from "./Index.vue?vue&type=template&id=f17d1fde&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=f17d1fde&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=f17d1fde&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1708464524/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f17d1fde"]])

export default __exports__